type Props = {}

const NoLikedArticles = (props: Props) => {
    return (
        <>
            <div
                style={{
                    fontSize: '36px',
                }}
            >
                You have not added any articles to Liked :(
            </div>
        </>
    )
}

export default NoLikedArticles
